module.exports = __webpack_public_path__ + "static/img/kuang.52415251.png";